export default "__VITE_ASSET__CvGHNz_u__"